// import type {} from '@mui/lab/themeAugmentation/index';
import { createStyles, createTheme } from '@mui/material/styles';

import { SxProps, useTheme } from '@mui/system';

import { Theme as SystemTheme } from '@mui/system/createTheme/createTheme';

declare module '@mui/material/styles' {
  interface PaletteColor {
    light: string;
    main: string;
    dark: string;
    contrastText: string;
  }

  interface SimplePaletteColorOptions {
    light?: string;
    main: string;
    dark?: string;
    contrastText?: string;
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#4B286D',
    },
    secondary: {
      main: '#ffffff',
    },
    error: {
      main: '#EB5757',
    },
    warning: {
      main: '#E2B93B',
    },
    info: {
      main: '#2F80ED',
    },
    success: {
      main: '#27AE60',
    },
  },
  typography: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
          @font-face {
      font-family: 'Inter';
      font-weight: 400;
     // src: local('Inter'), url('../../style/fonts/Inter/Inter-Regular.ttf') format('truetype');
  }
  `,
    },
  },
});

export const usePrimaryEffectEnhancement = (styles?: SxProps<SystemTheme>) => {
  const muiTheme = useTheme();
  return createStyles({
    ...styles,
    '&:hover': {
      color: muiTheme.palette.primary.dark,
    },
  });
};

export default theme;
